import { useEffect, useState } from 'react';
import { fetchSpecialties } from '../../providers/specialties';
import { Input, Select } from '../Field';
import { MinusCircleIcon } from '@heroicons/react/solid';

function SpecialtiesTab({ specialties: clinicSpecialties, t, old }) {
    const [specialties, setSpecialties] = useState([]);
    const [available, setAvailable] = useState([]);
    const [selected, setSelected] = useState(clinicSpecialties?.sort((a, b) => a.name.localeCompare(b.name)) || []);

    const changeHandler = (index, field, value) => {
        setSelected((oldValue) => {
            const newValue = [...oldValue];
            newValue[index][field] = value;
            newValue.sort((a, b) => a.name.localeCompare(b.name));
            return newValue;
        });
    };

    const removeHandler = (index) => {
        setSelected((oldValue) => {
            const newValue = [...oldValue];
            newValue.splice(index, 1);
            return newValue;
        });
    };

    const selectHandler = (e) => {
        const { id, name } = specialties.find(({ id }) => id == e.target.value);
        setSelected((oldValue) => [...oldValue, { id, name, price: 0, video: 0 }].sort((a, b) => a.name.localeCompare(b.name)));
    };

    useEffect(() => {
        fetchSpecialties().then(s => {
            setSpecialties(s);
            if (old?.specialties) {
                Object.entries(old.specialties).forEach(([key, value]) => {
                    if (!value) return;
                    const { price, video } = value;
                    const { id, name } = s.find(({ id }) => id == key);
                    setSelected((oldValue) => [...oldValue, { id, name, price: parseInt(price), video: parseInt(video) }].sort((a, b) => a.name.localeCompare(b.name)));            
                });
            }
        });
    }, []);

    useEffect(() => {
        setSelected(clinicSpecialties || []);
    }, [clinicSpecialties]);

    useEffect(() => {
        const selectedIds = selected.map((specialty) => specialty.id);
        setAvailable(specialties.filter(({ id }) => !selectedIds.includes(id)));
    }, [specialties, selected]);

    return (
        <div className="space-y-2">
            {selected.length ? (
                <div className="overflow-hidden rounded-md border border-gray-300 shadow-sm">
                    <table className="w-full">
                        <thead className="bg-gray-50">
                            <tr>
                                <th className="px-4 py-2 text-left font-medium">{t('specialty')}</th>
                                <th className="py-2 pr-4 text-left font-medium">{t('price')} (&euro;)</th>
                                {/* <th className="py-2 pr-4 font-medium text-left">Duração (min.)</th> */}
                                <th className="py-2 pr-4 text-left font-medium">{t('video-appointment')}</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody className="divide-y bg-white">
                            {selected.map(({ id, name, price, video }, index) => (
                                <tr key={index}>
                                    <td className="px-4 py-2">{name}</td>
                                    <td className="pr-2">
                                        <input
                                            type="number"
                                            min="0"
                                            step="0.05"
                                            name={`specialties[${id}][price]`}
                                            value={price}
                                            onChange={(e) => {
                                                changeHandler(index, 'price', e.target.value);
                                            }}
                                            className="w-24 border-none bg-transparent text-sm"
                                        />
                                    </td>
                                    {/* <td className="pr-2">
                                        <input
                                            type="number"
                                            min="0"
                                            name={`specialties[${id}][duration]`}
                                            className="w-20 text-sm bg-transparent border-none"
                                            value={duration}
                                            onChange={(e) => {
                                                changeHandler(index, 'duration', e.target.value);
                                            }}
                                        />
                                    </td> */}
                                    <td className="pr-2">
                                        <Input
                                            type="checkbox"
                                            checked={video}
                                            onChange={(e) => {
                                                changeHandler(index, 'video', e.target.checked ? 1 : 0);
                                            }}
                                        />
                                        <input type="hidden" name={`specialties[${id}][video]`} defaultValue={video} readOnly />
                                    </td>
                                    <td className="w-0 text-right text-xs">
                                        <button
                                            type="button"
                                            className="px-4 text-gray-500 hover:text-gray-800"
                                            onClick={() => {
                                                removeHandler(index);
                                            }}
                                        >
                                            <MinusCircleIcon className="relative top-[1px] h-5 w-5" />
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            ) : (
                <>
                    <input type="hidden" name="specialties[]" />
                    <div className="text-gray-500">- {t('no-specialties')}</div>
                </>
            )}

            <div className="w-72">
                <Select placeholder={t('add-specialty') + '...'} options={available} onChange={selectHandler} />
            </div>
        </div>
    );
}

export default SpecialtiesTab;
